import { LayoutGrid, LayoutList, KanbanSquare } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type ViewMode = "card" | "list" | "kanban";

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  label?: string;
  className?: string;
  allowedModes?: ViewMode[];
}

export const ViewToggle = ({ 
  viewMode, 
  onViewModeChange, 
  label = "View:", 
  className,
  allowedModes = ["card", "list"]
}: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      {label && (
        <span className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</span>
      )}
      <ToggleGroup 
        type="single" 
        value={viewMode} 
        onValueChange={(value) => value && onViewModeChange(value as ViewMode)}
        className={className}
      >
        <ToggleGroupItem value="card" aria-label="Card view">
          <LayoutGrid className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="list" aria-label="List view">
          <LayoutList className="h-4 w-4" />
        </ToggleGroupItem>
        {allowedModes.includes("kanban") && (
          <ToggleGroupItem value="kanban" aria-label="Kanban view">
            <KanbanSquare className="h-4 w-4" />
          </ToggleGroupItem>
        )}
      </ToggleGroup>
    </div>
  );
};
